import React, {Component} from 'react'
import './styles.css'

class Progress extends Component {
  render() {
    const {percent, label} = this.props
    return (
      <div className="progress">
        <div className="progress-bar">
          <div className="progress-completed" style={{transform: `scaleX(${percent})`}} />
        </div>
        <div className="progress-label">{label}</div>
      </div>
    )
  }
}

export default Progress



// WEBPACK FOOTER //
// ./src/components/Scores/Progress.js